var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"countdown",class:{'danger': _vm.isDanger, 'warning': _vm.isWarning}},[_c('div',[_c('p',{staticClass:"reservation"},[_vm._v("RESERVATION")]),_vm._v(" "),_c('p',{domProps:{"textContent":_vm._s(_vm.clockText)}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }